import { render } from "./page13.vue?vue&type=template&id=37b7c1a4&scoped=true"
import script from "./page13.vue?vue&type=script&lang=js"
export * from "./page13.vue?vue&type=script&lang=js"

import "./page13.vue?vue&type=style&index=0&id=37b7c1a4&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b7c1a4"]])

export default __exports__